import { MarkerIcon } from './MarkerIcon';

/**
 * author: Google
 * id 71E6D8F0-A3D2-43CB-8940-16AA4E1D9825
 * name marker
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/marker.svg
 * tags
 * - Text / Content / Format 
 */
export const HighlighterIcon = MarkerIcon;
export default HighlighterIcon